import { render } from "./ConfigDayInterval.vue?vue&type=template&id=7941953a&scoped=true&ts=true"
import script from "./ConfigDayInterval.vue?vue&type=script&lang=ts"
export * from "./ConfigDayInterval.vue?vue&type=script&lang=ts"

import "./ConfigDayInterval.vue?vue&type=style&index=0&id=7941953a&scoped=true&lang=scss"

import exportComponent from "/home/appstore/appstore/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7941953a"]])

export default __exports__